/* eslint-disable spire/export-styles */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Link from "@insite/mobius/Link/Link";
import { Modal } from "@insite/mobius/index";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import CrossIcon from "@NA/Icons/CrossIcon";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import { getUnitNetPrice } from "@insite/client-framework/Services/Helpers/ProductPriceService";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { canAddToCart, hasEnoughInventory } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import translate from "@insite/client-framework/Translate";
import {
    CartLineModel,
    ProductModel,
    ProductPriceDto,
    ProductSubscriptionDto,
} from "@insite/client-framework/Types/ApiModels";
import ProductAddedToCartMessage from "@insite/content-library/Components/ProductAddedToCartMessage";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Img from "@insite/mobius/Img";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import getColor from "@insite/mobius/utilities/getColor";
import CustomModel from "@NA/Components/ADICustomModal";
import ADIMinimumQtyModal from "@NA/Components/ADIMinimumQtyModal";
import CustomApplicationState from "@NA/Store/Data/CustomApplicationState/CustomApplicationState";
import MiniCartModal from "@NA/Widgets/Cart/MiniCartModal";
import React, { useContext, useEffect, useState } from "react";
import { connect, ResolveThunks, useSelector } from "react-redux";
import { css } from "styled-components";
import addToCart from "@NA/Overrides/Store/Pages/Cart/Handlers/AddToCart";
import loadProductAccessories from "@NA/Handlers/LoadProductAccessories";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { Typography } from "@insite/mobius/index";
import ADIColors from "@NA/Utils/ADIColors";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { checkAllowedQuantity, setPLPUrl } from "@NA/Utils/Utility";
import { pushDealerAuthDataToDataLayer } from "@NA/Overrides/Common/Utilities/CustomTracking";

interface OwnProps {
    labelOverride?: string;
    extendedStyles?: ButtonPresentationProps;
    notes?: string;
    configurationSelection?: SafeDictionary<string>;
    configurationCompleted?: boolean;
    variantSelectionCompleted?: boolean;
    subscription?: ProductSubscriptionDto;
    btnIsHidden?: boolean;
    onAddToCartClick?: () => void;
}

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasProductContext;

const mapStateToProps = (state: CustomApplicationState, props: OwnProps & HasProductContext) => {
    const currentPage = getCurrentPage(state).type;
    const isPdp = currentPage === "ProductDetailsPage";
    const isPlp = currentPage === "ProductListPage";
    const isComparePage = currentPage === "ProductComparePage";
    const adiUserRoles = state.ADIGlobalData.ADIUserRoleStore;
    const session = getSession(state);
    let customerNumber = "";
    const billToId = session?.billToId;
    if (billToId) {
        customerNumber = state.data.billTos.byId[billToId]?.customerNumber;
    }
    return {
        productSettings: getSettingsCollection(state).productSettings,
        canAddToCart: canAddToCart(
            state,
            props.productContext.product,
            props.productContext.productInfo,
            props.configurationCompleted,
            props.variantSelectionCompleted,
        ),
        session,
        customerNumber,
        hasEnoughInventory: hasEnoughInventory(state, props.productContext),
        addingProductToCart: state.context.isUpdatingCart,
        addToCartLoading: state.context.isUpdatingCart,
        updateCartLoading: state.pages.cart.isUpdatingCartLine,
        removeCartLineLoading: state.pages.cart.isRemovingCartLine,
        isCartLoading: getCurrentCartState(state).isLoading || state.ADIGlobalData.ADIUpdateCartLoading.loading,
        isPdp,
        isPlp,
        isComparePage,
        showADIAddToCart: (adiUserRoles.fullAccess && adiUserRoles.accounting) || adiUserRoles.fullAccess,
    };
};

const mapDispatchToProps = {
    addToCart: makeHandlerChainAwaitable(addToCart),
    loadProductAccessories,
};

export interface productAddToCartButtonStyles {
    addToCartBtn?: InjectableCss;
    cartIcon?: InjectableCss;
    cartLoadingIcon?: InjectableCss;
    availabilityByWarehouseModal?: ModalPresentationProps;
    continueShoppingButton?: InjectableCss;
    mainContainer?: InjectableCss;
    dealerMsg?: InjectableCss;
    vendorLink?: InjectableCss;
}
export const productAddToCartButtonStyles: productAddToCartButtonStyles = {
    mainContainer: {
        css: css`
            align-self: center;
            padding-top: 20px;
            background: grren !important;
            span {
                // background:green !important;
            }
            span[role="checkbox"] + label {
                margin-left: 10px;
                font-size: 16px;
                font-weight: 800;
                color: #2d2926;
                line-height: normal;
            }

            span[role="checkbox"][aria-checked="true"]:not([aria-disabled="true"]) {
                background: green !important;
            }
        `,
    },
    addToCartBtn: {
        css: css`
            max-width: 200px !important;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 15px;

            > ${TypographyStyle} {
                font-size: 14px;
                font-weight: 800;
            }
            &:disabled {
                background: ${ADIColors.blue5};
                border: 2px solid ${ADIColors.blue5};
            }
        `,
    },
    continueShoppingButton: {
        css: css`
            margin-top: 20px;
            display: block;
        `,
    },
    availabilityByWarehouseModal: {
        sizeVariant: "medium",
        closeButtonIconProps: {
            src: CrossIcon,
            size: 20,
        },
        cssOverrides: {
            modalBody: css`
                max-width: 730px !important;
                border-radius: 4px;
                padding: 28px !important;
            `,
            modalContent: css`
                padding: 0;
            `,
            modalTitle: css`
                border-bottom: 0;
                padding: 0 !important;
                margin-bottom: 20px;
                > h4 {
                    font-size: 32px;
                    font-weight: bold;
                    font-family: "Nunito Sans", sans-serif;
                    line-height: normal;
                    color: ${ADIColors.darkBlue1};
                }
                button {
                    border-radius: 0;
                    svg {
                        height: 20px;
                    }
                }
            `,
            headlineTypography: css`
                font-size: 20px;
                margin-bottom: 0;
            `,
        },
    },
    cartLoadingIcon: {
        css: css`
            height: 33px;
            width: 33px;
            left: 0px;
            bottom: 0px;
        `,
    },
    cartIcon: {
        css: css`
            height: 18px;
            width: 18px;
            left: 0px !important;
            margin-right: 15px;
            top: 8px;
        `,
    },
    dealerMsg: {
        css: css`
            padding-bottom: 20px;
            font-size: 14px;
            line-height: 1.71;
            font-weight: normal;
        `,
    },
    vendorLink: {
        css: css`
            margin-left: 2px;
        `,
    },
};

const ProductAddToCartButton = ({
    productContext: {
        product,
        product: { id: productId, allowZeroPricing, quoteRequired, productNumber, properties, erpNumber },
        productInfo: { qtyOrdered, unitOfMeasure, pricing, inventory },
        onQtyOrderedChanged,
    },
    productSettings,
    hasEnoughInventory,
    addingProductToCart,
    addToCart,
    canAddToCart,
    labelOverride,
    extendedStyles,
    notes,
    configurationSelection,
    configurationCompleted,
    variantSelectionCompleted,
    subscription,
    addToCartLoading,
    btnIsHidden,
    isPdp,
    isPlp,
    isComparePage,
    showADIAddToCart,
    updateCartLoading,
    removeCartLineLoading,
    loadProductAccessories,
    isCartLoading,
    customerNumber,
    session,
    onAddToCartClick,
    ...otherProps
}: Props) => {
    const showAuthorizationRequired =
        pricing &&
            pricing.additionalResults &&
            pricing.additionalResults.isVisible &&
            pricing.additionalResults.isVisible === "N"
            ? true
            : false;
    
    const vendorAuthRequiredList = product?.properties?.vendorAuthRequiredList?.toLowerCase();
    const brandName = product.brand?.name ?? "";
    const vendorAuthRequiredLink = product?.properties?.vendorAuthRequiredLink;

    const clickHandler = () => {
        pushDealerAuthDataToDataLayer(brandName, vendorAuthRequiredLink, customerNumber, "Product List", session);
    };

    const getCustomerCreditStatus = useSelector(
        (state: CustomApplicationState) => state.ADIGlobalData.PricingStatusStore,
    );



    const toasterContext = useContext(ToasterContext);
    const [styles] = useState(() => mergeToNew(productAddToCartButtonStyles, extendedStyles));
    const [isMiniCartModalOpen, setIsMiniCartModalOpen] = useState(false);
    const [cartLineState, setCartLineState] = useState<CartLineModel>();
    const [selectedProduct, setSelectedProduct] = useState("");
    const [dealerModalIsOpen, setDealerModalIsOpen] = React.useState(false);

    const [isMinimumQtyOpen, setIsMinimumQtyOpen] = useState(false);

    const openMiniCartHandler = () => setIsMiniCartModalOpen(true);
    const [isItemAdded, setisItemAdded] = useState(true);

    const closeMiniCartHandler = () => {
        setIsMiniCartModalOpen(false);
        setCartLineState(undefined);
    };

    const getCertified = () => {
        setDealerModalIsOpen(true);
    };

    const dealerModalCloseHandler = () => {
        setDealerModalIsOpen(false);
    };

    const closeMinimumQtyCard = () => setIsMinimumQtyOpen(false);

    const addToCartClickHandler = async () => {
        sessionStorage.setItem("item_list_name", "Product List Page");
        if (isPdp || isComparePage) {
            if (isPdp) {
                sessionStorage.setItem("item_list_name", "Product Detail Page");
            }
            if (!checkAllowedQuantity(Number(qtyOrdered), Number(properties.minimuM_QTY))) {
                setIsMinimumQtyOpen(true);
                return;
            }
        }
        setSelectedProduct(productNumber);
        if (!quoteRequired && !allowZeroPricing && pricing && getUnitNetPrice(pricing, 1).price === 0) {
            toasterContext.addToast({ body: siteMessage("Cart_InvalidPrice"), messageType: "danger" });
            return;
        }

        const sectionOptions =
            configurationSelection && Object.values(configurationSelection).length > 0
                ? Object.values(configurationSelection)
                    .filter(sectionOptionId => !!sectionOptionId)
                    .map(sectionOptionId => ({ sectionOptionId }))
                : undefined;

        // ADINA-52733 : load accessorieswidget when cart modal appears
        if (isPlp || isPdp) {
            loadProductAccessories({ erpNumber: productNumber });
        }

        const orderQty = qtyOrdered || parseInt(properties.minimuM_QTY, 10);
        const cartline = (await addToCart({
            productId,
            qtyOrdered: orderQty,
            unitOfMeasure,
            notes,
            sectionOptions,
            subscription,
        })) as CartLineModel;

        if (productSettings.showAddToCartConfirmationDialog && cartline) {
            setCartLineState(cartline);

            setSelectedProduct("");

            if (!isComparePage) {
                openMiniCartHandler();
                setisItemAdded(false);
            }

            if (isComparePage) {
                setisItemAdded(false);
                onAddToCartClick?.();
            }
        }
    };

    const isRemoveCartItem = () => {
        if (Object.keys(removeCartLineLoading).length) {
            return true;
        }
        return false;
    };

    React.useEffect(() => {
        setPLPUrl(window.location.pathname)
    }, [])
    const [btnDisabled, setbtnDisabled] = React.useState(getCustomerCreditStatus?.getcustomerStatus?.creditStatus)
    useEffect(() => {
        setbtnDisabled(getCustomerCreditStatus?.getcustomerStatus?.creditStatus)
    }, [btnDisabled, getCustomerCreditStatus?.getcustomerStatus?.creditStatus])
    return (
        <>
            {!btnIsHidden &&
                showADIAddToCart &&
                isComparePage &&
                isItemAdded &&
                (showAuthorizationRequired ? false : true) &&
                pricing !== undefined ? (
                <Button
                    {...styles.addToCartBtn}
                    onClick={addToCartClickHandler}
                    disabled={qtyOrdered <= 0 || addingProductToCart}
                    {...otherProps}
                >
                    {addToCartLoading && selectedProduct === productNumber ? (
                        <Img
                            {...styles.cartLoadingIcon}
                            src="https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/icons/rd-addtocart-loader.gif"
                        />
                    ) : (
                        <Img
                            {...styles.cartIcon}
                            src="https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/home/cart-icon.svg"
                        />
                    )}
                    <Typography>{translate("ADD TO CART")}</Typography>
                </Button>
            ) : (
                showAuthorizationRequired && (
                    <StyledWrapper>
                        <StyledWrapper>Dealer Certification Required</StyledWrapper>
                        <Link onClick={getCertified}>Get Certified</Link>

                        <Modal
                            {...styles.availabilityByWarehouseModal}
                            headline={translate("Dealer Certification Required")}
                            isOpen={dealerModalIsOpen}
                            handleClose={dealerModalCloseHandler}
                        >
                            {vendorAuthRequiredList === "true" ? (
                                <StyledWrapper {...styles.dealerMsg}>
                                    {siteMessage("Dealer_Vendor_Certification_Message")}
                                    <Link
                                        href={product.properties?.vendorAuthRequiredLink}
                                        target="_blank"
                                        onClick={clickHandler}
                                        {...styles.vendorLink}
                                    >
                                        {" "}
                                        {translate(" vendor's form.")}
                                    </Link>{" "}
                                    {translate("For more information, call ")}
                                    <StyledWrapper as="span">1.877.228.6739.</StyledWrapper>
                                </StyledWrapper>
                            ) : (
                                siteMessage("Dealer_Certification_Message")
                            )}
                            {/* 
                            <Button {...styles.continueShoppingButton} onClick={dealerModalCloseHandler}>
                                Continue Shopping
                            </Button> */}
                        </Modal>
                    </StyledWrapper>
                )
            )}

            {!btnIsHidden && showADIAddToCart && !isComparePage && (
                <Button
                    {...styles}
                    onClick={addToCartClickHandler}
                    disabled={
                        qtyOrdered <= 0 ||
                        addingProductToCart ||
                        updateCartLoading ||
                        isRemoveCartItem() ||
                        (btnDisabled !== "O" && btnDisabled !== "" && btnDisabled !== null)
                    }
                    {...otherProps}
                >
                    {addToCartLoading && selectedProduct === productNumber ? (
                        <Img src="https://cdn.adiglobaldistribution.us/userfile-na/US/userfiles/Images/Themes/icons/rd-addtocart-loader.gif" />
                    ) : (
                        labelOverride ?? translate("Add to Cart")
                    )}
                </Button>
            )}
            {isComparePage && !isItemAdded && (
                <Checkbox {...styles.mainContainer} checked={true} onChange={() => { }}>
                    {translate("ITEM ADDED")}
                </Checkbox>
            )}
            {cartLineState && (
                <MiniCartModal
                    isModalOpen={isMiniCartModalOpen}
                    onModalClose={closeMiniCartHandler}
                    cartLine={cartLineState}
                    quantityOrdered={isPdp ? qtyOrdered : parseInt(properties.minimuM_QTY) || qtyOrdered}
                />
            )}

            <ADIMinimumQtyModal
                headline="Add to Cart Message"
                isOpen={isMinimumQtyOpen}
                errorStyle={false}
                handleClose={closeMinimumQtyCard}
            >
                <>{translate(`Must be purchased in quantities of ${properties.minimuM_QTY}`)}</>
            </ADIMinimumQtyModal>
        </>
    );
};
export default withProductContext(connect(mapStateToProps, mapDispatchToProps)(ProductAddToCartButton));
